import React, { useState } from "react";
import { Plus, X } from "lucide-react";

export function SpecialtyPicker({ value = [], onChange, options = [], max = 8, testId = "specialties" }) {
  const [custom, setCustom] = useState("");
  const toggle = (s) => {
    if (value.includes(s)) onChange(value.filter((v) => v !== s));
    else if (value.length < max) onChange([...value, s]);
  };
  const addCustom = () => {
    const s = custom.trim();
    if (s && !value.includes(s) && value.length < max) onChange([...value, s]);
    setCustom("");
  };
  const extras = value.filter((v) => !options.includes(v));
  return (
    <div data-testid={testId}>
      <div className="flex flex-wrap gap-2">
        {[...options, ...extras].map((s) => {
          const on = value.includes(s);
          return (
            <button key={s} type="button" onClick={() => toggle(s)} data-testid={`${testId}-opt-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} aria-pressed={on}
              className={`inline-flex items-center gap-1 rounded-full px-3.5 h-10 text-sm font-bold transition-colors ${on ? "bg-ink text-white" : "bg-white border border-border text-ink-soft hover:border-coral"}`}>
              {s}{on && <X size={13} />}
            </button>
          );
        })}
      </div>
      <div className="mt-3 flex gap-2">
        <input value={custom} onChange={(e) => setCustom(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addCustom(); } }}
          data-testid={`${testId}-custom`} placeholder="Add your own (e.g. Parsi)"
          className="h-11 flex-1 min-w-0 rounded-xl border border-border bg-white px-4 text-base outline-none focus:border-coral focus:ring-4 focus:ring-coral/10 font-medium" />
        <button type="button" onClick={addCustom} data-testid={`${testId}-custom-add`} className="inline-flex items-center gap-1 h-11 px-4 rounded-xl border border-border bg-white font-bold text-ink hover:border-coral"><Plus size={16} /> Add</button>
      </div>
      <p className="mt-1.5 text-xs text-ink-soft">{value.length}/{max} selected</p>
    </div>
  );
}
